import { publicClient, privateClient } from '../apiClient';
import { DEMO_LESSON, DEMO_COMPLETE_RESPONSE } from '../../mocks/course/lessonMocks';
import { DEMO_COURSES, DEMO_COURSE_OUTLINE, DEMO_COURSE_OUTLINE_FLAT } from '../../mocks/course/courseMocks';
import type { Lesson, Com} from '../../types/course/Lesson';

class LessonService {
    private useMock = import.meta.env.VITE_USE_MOCK === 'true';

    async fetchLesson(courseId: string, lessonId: string): Promise<Lesson> {
        if (this.useMock)
            return DEMO_LESSON;
        const response = await publicClient.get(`/courses/${courseId}/lessons/${lessonId}`);
        return response.data;
    }

    async completeLesson(courseId: string, lessonId: string):Promise<CompleteResponse> {
        if (this.useMock) {
            const item = DEMO_COURSE_OUTLINE_FLAT.find(item => item.id === lessonId);
            if (item) item.completed = true;
            const completedCount = DEMO_COURSE_OUTLINE_FLAT.filter(item => item.completed).length;
            return {
                completed: true,
                completedCount,
                percent: Math.round((completedCount / DEMO_COURSE_OUTLINE_FLAT.length) * 100),
            };
        }
        const response = await privateClient.post(`/courses/${courseId}/lessons/${lessonId}/complete`);
        return response.data;
    }
}

export default new LessonService();